import { CookieAttributes, get, remove, set } from 'js-cookie';

export enum SolaForceCookie {
  CurrentPage = 'sola-current-page',
  LoginRedirect = 'login-redirect', // ??? Used in legacy, but for what?
  Dev_LoginContinueOnLastPage = 'loginContinueOnLastPage',
}

export const useCookie = <T extends object = object>(
  cookieName: SolaForceCookie | string,
) => {
  return {
    value: get(cookieName),
    setValue: (value: string | T, options?: CookieAttributes) =>
      set(cookieName, value, options),
    remove: (options?: CookieAttributes) => remove(cookieName, options),
  };
};
